import { computed, inject, Injectable, signal } from '@angular/core';
import { VolunteerSignupMentorDetails } from '@interfaces';
import { AppService, FuncService } from "../../../../services";


@Injectable({
	providedIn: 'root'
})
export class MentorSignUpViewerDialogDataService {

	private func = inject(FuncService);
	private app = inject(AppService);
	mentorSignUpDetails = signal<VolunteerSignupMentorDetails | undefined>(undefined);

	public canEdit = computed(() => this.app.data().permissions.canCoordinateVolunteers);

	public async getVolunteerSignupMentorData(volunteerSignupMentorId: number) {
		const response = await this.func.volunteering.mentorSignUp.getMentorSignup({ volunteerSignupMentorId });
		if (response) this.mentorSignUpDetails.set(response);
	}

}